
import React from "react";
import { useParams, Navigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import Breadcrumb from "@/components/Breadcrumb";
import StructuredData from "@/components/StructuredData";
import GeoLocalizedContent from "@/components/seo/GeoLocalizedContent";
import { useGeoLocalizedData } from "@/hooks/useGeoLocalizedData";

const DepartmentPage: React.FC = () => {
  const { departmentCode } = useParams<{ departmentCode: string }>();
  const { departmentData, localBusinessSchema, seoMetadata, isValidDepartment } = useGeoLocalizedData(departmentCode);

  // Rediriger si le département n'existe pas
  if (!isValidDepartment || !departmentData || !seoMetadata) {
    return <Navigate to="/nos-services" replace />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title={seoMetadata.title}
        description={seoMetadata.description}
        canonical={`/services/departement/${departmentCode}`}
        keywords={seoMetadata.keywords}
        localBusiness={{
          city: departmentData.mainCities[0],
          region: departmentData.name,
          postalCode: departmentCode + "000",
          serviceType: "Gestion des déchets"
        }}
      />
      
      {localBusinessSchema && <StructuredData data={localBusinessSchema} />}
      
      <Navbar />
      
      <main className="flex-1 pt-20">
        <nav aria-label="Fil d'Ariane" className="bg-gray-50 py-3 border-b border-gray-200">
          <div className="container mx-auto px-4">
            <Breadcrumb
              items={[
                { label: "Accueil", href: "/" },
                { label: "Services", href: "/nos-services" },
                { label: `${departmentData.name} (${departmentCode})`, href: `/services/departement/${departmentCode}`, current: true }
              ]}
            />
          </div>
        </nav>

        <article className="py-12">
          <div className="container mx-auto px-4">
            <GeoLocalizedContent content={departmentData} />
          </div>
        </article>
      </main>

      <Footer />
    </div>
  );
};

export default DepartmentPage;
